module.exports = __webpack_public_path__ + "4d35f4b542cf9f1b309ffd637bbf2c00.pdf";